import { DocumentNode, gql } from '@apollo/client';

// Statisches Dokument mit GraphQL-Variablen (keine String-Interpolation mehr).
export const getAllDocumentsByCorrelationIdQuery: DocumentNode = gql`
  query GetAllDocumentsByCorrelationId($correlationId: String!) {
    allDocumentsByCorrelationId(correlationId: $correlationId) {
      id
      data
    }
  }
`;
